;(function () {
  'use strict'
  var l
  function aa(a) {
    var b = 0
    return function () {
      return b < a.length ? { done: !1, value: a[b++] } : { done: !0 }
    }
  }
  function q(a) {
    var b =
      'undefined' != typeof Symbol && Symbol.iterator && a[Symbol.iterator]
    return b ? b.call(a) : { next: aa(a) }
  }
  function r(a, b) {
    this.j = a
    this.h = b
    this.I = this.j.document
    this.P = this.N = !1
    this.G = null
  }
  r.prototype.buildCallback = function () {
    this.N || (this.X(), (this.N = !0))
  }
  r.prototype.layoutCallback = function () {
    this.P || (this.P = !0)
  }
  r.prototype.X = function () {
    this.G = this.I.createElement('main')
    var a = this.h.attachShadow({ mode: 'open' }),
      b = this.I.createElement('style')
    b.textContent =
      'amp-story-entry-point{position:relative;display:block}\n/*# sourceURL=/css/amp-story-entry-point.css*/'
    a.appendChild(b)
    a.appendChild(this.G)
  }
  r.prototype.getElement = function () {
    return this.h
  }
  var t
  function u() {
    return t ? t : (t = Promise.resolve(void 0))
  }
  function w() {
    var a = this
    this.promise = new Promise(function (b, c) {
      a.resolve = b
      a.reject = c
    })
  }
  var ba = 'ase art bmp blp cd5 cit cpt cr2 cut dds dib djvu egt exif gif gpl grf icns ico iff jng jpeg jpg jfif jp2 jps lbm max miff mng msp nitf ota pbm pc1 pc2 pc3 pcf pcx pdn pgm PI1 PI2 PI3 pict pct pnm pns ppm psb psd pdd psp px pxm pxr qfx raw rle sct sgi rgb int bw tga tiff tif vtf xbm xcf xpm 3dv amf ai awg cgm cdr cmx dxf e2d egt eps fs gbr odg svg stl vrml x3d sxd v2d vnd wmf emf art xar png webp jxr hdp wdp cur ecw iff lbm liff nrrd pam pcx pgf sgi rgb rgba bw int inta sid ras sun tga'.split(
    ' '
  )
  function ca(a) {
    return ba.some(function (b) {
      return a.endsWith('.' + b) ? !0 : !1
    })
  }
  var da = '### #gf $on $tf 0b 8m 8u 12u 15u 64c 075 75 085 85 91 091 096 96 abf acfm acs afm afn afs all amfm apf asf aspf atm auf b30 bco bdf bepf bez bfn bmap bmf bx bzr cbtf cct cef cff cfn cga ch4 cha chm chr chx claf collection compositefont dfont dus dzk eft eot etx euf f00 f06 f08 f09 f3f f10 f11 f12 f13 f16 fd fdb ff ffil flf fli fn3 fnb fnn fnt fnta fo1 fo2 fog fon font fonts fot frf frs ftm fxr fyi gdr gf gft glf glif glyphs gsf gxf hbf ice intellifont lepf lft lwfn mcf mcf mfd mfm mft mgf mmm mrf mtf mvec nlq ntf odttf ofm okf otf pcf pcf pfa pfb pfm pft phf pk pkt prs pss qbf qfn r8? scr sfd sff sfi sfl sfn sfo sfp sfs sif snf spd spritefont sui suit svg sxs t1c t2 tb1 tb2 tdf tfm tmf tpf ttc tte ttf type ufm ufo usl usp us? vf vf1 vf3 vfb vfm vfont vlw vmf vnf w30 wfn wnf woff woff2 xfc xfn xfr xft zfi zsu _v'.split(
    ' '
  )
  function ea(a) {
    return da.some(function (b) {
      return a.endsWith('.' + b) ? !0 : !1
    })
  }
  var fa =
    'undefined' !== typeof globalThis
      ? globalThis
      : 'undefined' !== typeof window
      ? window
      : 'undefined' !== typeof global
      ? global
      : 'undefined' !== typeof self
      ? self
      : {}
  function ha(a, b) {
    b = b.split(':')[0]
    a = +a
    if (!a) return !1
    switch (b) {
      case 'http':
      case 'ws':
        return 80 !== a
      case 'https':
      case 'wss':
        return 443 !== a
      case 'ftp':
        return 21 !== a
      case 'gopher':
        return 70 !== a
      case 'file':
        return !1
    }
    return 0 !== a
  }
  var ia = Object.prototype.hasOwnProperty
  function ja(a) {
    try {
      return decodeURIComponent(a.replace(/\+/g, ' '))
    } catch (b) {
      return null
    }
  }
  function ka(a, b) {
    b = b || ''
    var c = [],
      d
    'string' !== typeof b && (b = '?')
    for (e in a)
      if (ia.call(a, e)) {
        ;(d = a[e]) || (null !== d && void 0 !== d && !isNaN(d)) || (d = '')
        var e = encodeURIComponent(e)
        d = encodeURIComponent(d)
        null !== e && null !== d && c.push(e + '=' + d)
      }
    return c.length ? b + c.join('&') : ''
  }
  function la(a) {
    for (var b = /([^=?&]+)=?([^&]*)/g, c = {}, d; (d = b.exec(a)); ) {
      var e = ja(d[1])
      d = ja(d[2])
      null === e || null === d || e in c || (c[e] = d)
    }
    return c
  }
  var ma = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//,
    na = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i,
    oa = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/,
    x = [
      ['#', 'hash'],
      ['?', 'query'],
      function (a) {
        return a.replace('\\', '/')
      },
      ['/', 'pathname'],
      ['@', 'auth', 1],
      [NaN, 'host', void 0, 1, 1],
      [/:(\d+)$/, 'port', void 0, 1],
      [NaN, 'hostname', void 0, 1, 1],
    ],
    pa = { hash: 1, query: 1 }
  function y(a, b, c) {
    a = (a ? a : '').toString().replace(oa, '')
    if (!(this instanceof y)) return new y(a, b, c)
    var d = x.slice(),
      e = typeof b,
      g = 0
    'object' !== e && 'string' !== e && ((c = b), (b = null))
    c && 'function' !== typeof c && (c = la)
    e =
      ('undefined' !== typeof window
        ? window
        : 'undefined' !== typeof fa
        ? fa
        : 'undefined' !== typeof self
        ? self
        : {}
      ).location || {}
    b = b || e
    e = {}
    var f = typeof b
    if ('blob:' === b.protocol) e = new y(unescape(b.pathname), {})
    else if ('string' === f) for (h in ((e = new y(b, {})), pa)) delete e[h]
    else if ('object' === f) {
      for (h in b) h in pa || (e[h] = b[h])
      void 0 === e.slashes && (e.slashes = ma.test(b.href))
    }
    b = e
    a = a || ''
    a = (a ? a : '').toString().replace(oa, '')
    a = na.exec(a)
    var h = {
      protocol: a[1] ? a[1].toLowerCase() : '',
      slashes: !!a[2],
      rest: a[3],
    }
    e = !h.protocol && !h.slashes
    this.slashes = h.slashes || (e && b.slashes)
    this.protocol = h.protocol || b.protocol || ''
    a = h.rest
    for (h.slashes || (d[3] = [/(.*)/, 'pathname']); g < d.length; g++)
      if (((h = d[g]), 'function' === typeof h)) a = h(a)
      else {
        f = h[0]
        var k = h[1]
        if (f !== f) this[k] = a
        else if ('string' === typeof f)
          ~(f = a.indexOf(f)) &&
            ('number' === typeof h[2]
              ? ((this[k] = a.slice(0, f)), (a = a.slice(f + h[2])))
              : ((this[k] = a.slice(f)), (a = a.slice(0, f))))
        else if ((f = f.exec(a))) (this[k] = f[1]), (a = a.slice(0, f.index))
        this[k] = this[k] || (e && h[3] ? b[k] || '' : '')
        h[4] && (this[k] = this[k].toLowerCase())
      }
    c && (this.query = c(this.query))
    if (
      e &&
      b.slashes &&
      '/' !== this.pathname.charAt(0) &&
      ('' !== this.pathname || '' !== b.pathname)
    ) {
      a = this.pathname
      b = b.pathname
      if ('' !== a) {
        b = (b || '/').split('/').slice(0, -1).concat(a.split('/'))
        a = b.length
        c = b[a - 1]
        d = !1
        for (g = 0; a--; )
          '.' === b[a]
            ? b.splice(a, 1)
            : '..' === b[a]
            ? (b.splice(a, 1), g++)
            : g && (0 === a && (d = !0), b.splice(a, 1), g--)
        d && b.unshift('')
        ;('.' !== c && '..' !== c) || b.push('')
        b = b.join('/')
      }
      this.pathname = b
    }
    ha(this.port, this.protocol) ||
      ((this.host = this.hostname), (this.port = ''))
    this.username = this.password = ''
    this.auth &&
      ((h = this.auth.split(':')),
      (this.username = h[0] || ''),
      (this.password = h[1] || ''))
    this.origin =
      this.protocol && this.host && 'file:' !== this.protocol
        ? this.protocol + '//' + this.host
        : 'null'
    this.href = this.toString()
  }
  y.prototype = {
    set: function (a, b, c) {
      switch (a) {
        case 'query':
          'string' === typeof b && b.length && (b = (c || la)(b))
          this[a] = b
          break
        case 'port':
          this[a] = b
          ha(b, this.protocol)
            ? b && (this.host = this.hostname + ':' + b)
            : ((this.host = this.hostname), (this[a] = ''))
          break
        case 'hostname':
          this[a] = b
          this.port && (b += ':' + this.port)
          this.host = b
          break
        case 'host':
          this[a] = b
          ;/:\d+$/.test(b)
            ? ((b = b.split(':')),
              (this.port = b.pop()),
              (this.hostname = b.join(':')))
            : ((this.hostname = b), (this.port = ''))
          break
        case 'protocol':
          this.protocol = b.toLowerCase()
          this.slashes = !c
          break
        case 'pathname':
        case 'hash':
          b
            ? ((c = 'pathname' === a ? '/' : '#'),
              (this[a] = b.charAt(0) !== c ? c + b : b))
            : (this[a] = b)
          break
        default:
          this[a] = b
      }
      for (a = 0; a < x.length; a++)
        (b = x[a]), b[4] && (this[b[1]] = this[b[1]].toLowerCase())
      this.origin =
        this.protocol && this.host && 'file:' !== this.protocol
          ? this.protocol + '//' + this.host
          : 'null'
      this.href = this.toString()
      return this
    },
    toString: function (a) {
      ;(a && 'function' === typeof a) || (a = ka)
      var b = this.protocol
      b && ':' !== b.charAt(b.length - 1) && (b += ':')
      b += this.slashes ? '//' : ''
      this.username &&
        ((b += this.username),
        this.password && (b += ':' + this.password),
        (b += '@'))
      b += this.host + this.pathname
      ;(a = 'object' === typeof this.query ? a(this.query) : this.query) &&
        (b += '?' !== a.charAt(0) ? '?' + a : a)
      this.hash && (b += this.hash)
      return b
    },
  }
  var qa = /^xn--/,
    ra = /[^\0-\x7E]/,
    sa = /[\x2E\u3002\uFF0E\uFF61]/g,
    ta = {
      overflow: 'Overflow: input needs wider integers to process',
      'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
      'invalid-input': 'Invalid input',
    },
    z = Math.floor,
    B = String.fromCharCode
  function C(a) {
    throw new RangeError(ta[a])
  }
  function ua(a, b) {
    var c = a.split('@'),
      d = ''
    1 < c.length && ((d = c[0] + '@'), (a = c[1]))
    a = a.replace(sa, '.')
    a = a.split('.')
    c = []
    for (var e = a.length; e--; ) c[e] = b(a[e])
    b = c.join('.')
    return d + b
  }
  function va(a, b, c) {
    var d = 0
    a = c ? z(a / 700) : a >> 1
    for (a += z(a / b); 455 < a; d += 36) a = z(a / 35)
    return z(d + (36 * a) / (a + 38))
  }
  function wa(a) {
    return ua(a, function (b) {
      if (ra.test(b)) {
        var c = []
        for (var d = [], e = 0, g = b.length; e < g; ) {
          var f = b.charCodeAt(e++)
          if (55296 <= f && 56319 >= f && e < g) {
            var h = b.charCodeAt(e++)
            56320 == (h & 64512)
              ? d.push(((f & 1023) << 10) + (h & 1023) + 65536)
              : (d.push(f), e--)
          } else d.push(f)
        }
        b = d
        d = b.length
        e = 128
        g = 0
        f = 72
        var k = q(b)
        for (h = k.next(); !h.done; h = k.next())
          (h = h.value), 128 > h && c.push(B(h))
        for ((k = h = c.length) && c.push('-'); k < d; ) {
          for (
            var m = 2147483647, p = q(b), n = p.next();
            !n.done;
            n = p.next()
          )
            (n = n.value), n >= e && n < m && (m = n)
          p = k + 1
          m - e > z((2147483647 - g) / p) && C('overflow')
          g += (m - e) * p
          e = m
          n = q(b)
          for (m = n.next(); !m.done; m = n.next())
            if (
              ((m = m.value),
              m < e && 2147483647 < ++g && C('overflow'),
              m == e)
            ) {
              var v = g
              for (m = 36; ; m += 36) {
                var A = m <= f ? 1 : m >= f + 26 ? 26 : m - f
                if (v < A) break
                v -= A
                var xa = 36 - A,
                  ya = c
                A += v % xa
                ya.push.call(ya, B(A + 22 + 75 * (26 > A) - 0))
                v = z(v / xa)
              }
              c.push(B(v + 22 + 75 * (26 > v) - 0))
              f = va(g, p, k == h)
              g = 0
              ++k
            }
          ++g
          ++e
        }
        c = 'xn--' + c.join('')
      } else c = b
      return c
    })
  }
  function za(a) {
    return ua(a, function (b) {
      if (qa.test(b)) {
        var c = b.slice(4).toLowerCase()
        b = []
        var d = c.length,
          e = 0,
          g = 128,
          f = 72,
          h = c.lastIndexOf('-')
        0 > h && (h = 0)
        for (var k = 0; k < h; ++k)
          128 <= c.charCodeAt(k) && C('not-basic'), b.push(c.charCodeAt(k))
        for (h = 0 < h ? h + 1 : 0; h < d; ) {
          k = e
          for (var m = 1, p = 36; ; p += 36) {
            h >= d && C('invalid-input')
            var n = c.charCodeAt(h++)
            n =
              10 > n - 48
                ? n - 22
                : 26 > n - 65
                ? n - 65
                : 26 > n - 97
                ? n - 97
                : 36
            ;(36 <= n || n > z((2147483647 - e) / m)) && C('overflow')
            e += n * m
            var v = p <= f ? 1 : p >= f + 26 ? 26 : p - f
            if (n < v) break
            n = 36 - v
            m > z(2147483647 / n) && C('overflow')
            m *= n
          }
          n = b.length + 1
          f = va(e - k, n, 0 == k)
          z(e / n) > 2147483647 - g && C('overflow')
          g += z(e / n)
          e %= n
          b.splice(e++, 0, g)
        }
        c = String.fromCodePoint
        d = c.apply
        e = String
        if (!(b instanceof Array)) {
          b = q(b)
          for (f = []; !(g = b.next()).done; ) f.push(g.value)
          b = f
        }
        b = d.call(c, e, b)
      }
      return b
    })
  }
  function Aa(a) {
    a = new TextEncoder('utf-8').encode(a)
    return window.crypto.subtle.digest('SHA-256', a).then(function (b) {
      var c = []
      b = new DataView(b)
      for (var d = 0; d < b.byteLength; d += 4) {
        var e = ('00000000' + b.getUint32(d).toString(16)).slice(-8)
        c.push(e)
      }
      return c.join('')
    })
  }
  var Ba = /[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/,
    Ca = /[\u0591-\u06ef\u06fa-\u07ff\u200f\ufb1d-\ufdff\ufe70-\ufefc]/
  function Da(a) {
    a = new y(a).hostname
    if (Ea(a)) var b = !1
    else
      (b = za(a)),
        (b =
          63 >= a.length && !(Ba.test(b) && Ca.test(b)) && -1 != a.indexOf('.'))
    if (b) {
      b = za(a)
      b = b.split('-').join('--')
      b = b.split('.').join('-')
      b = wa(b).toLowerCase()
      if (63 < b.length) return Fa(a)
      Ea(b) && (b = '0-'.concat(b, '-0'))
      return Promise.resolve(b)
    }
    return Fa(a)
  }
  function Fa(a) {
    a = 'undefined' !== typeof window ? Aa(a) : void 0
    return a.then(function (b) {
      return Ga('ffffffffff' + b + '000000').substr(
        8,
        Math.ceil((4 * b.length) / 5)
      )
    })
  }
  function Ga(a) {
    var b = []
    a.match(/.{1,2}/g).forEach(function (g, f) {
      b[f] = parseInt(g, 16)
    })
    var c = b.length % 5,
      d = Math.floor(b.length / 5)
    a = []
    if (0 != c) {
      for (var e = 0; e < 5 - c; e++) b += '\x00'
      d += 1
    }
    for (e = 0; e < d; e++)
      a.push('abcdefghijklmnopqrstuvwxyz234567'.charAt(b[5 * e] >> 3)),
        a.push(
          'abcdefghijklmnopqrstuvwxyz234567'.charAt(
            ((b[5 * e] & 7) << 2) | (b[5 * e + 1] >> 6)
          )
        ),
        a.push(
          'abcdefghijklmnopqrstuvwxyz234567'.charAt((b[5 * e + 1] & 63) >> 1)
        ),
        a.push(
          'abcdefghijklmnopqrstuvwxyz234567'.charAt(
            ((b[5 * e + 1] & 1) << 4) | (b[5 * e + 2] >> 4)
          )
        ),
        a.push(
          'abcdefghijklmnopqrstuvwxyz234567'.charAt(
            ((b[5 * e + 2] & 15) << 1) | (b[5 * e + 3] >> 7)
          )
        ),
        a.push(
          'abcdefghijklmnopqrstuvwxyz234567'.charAt((b[5 * e + 3] & 127) >> 2)
        ),
        a.push(
          'abcdefghijklmnopqrstuvwxyz234567'.charAt(
            ((b[5 * e + 3] & 3) << 3) | (b[5 * e + 4] >> 5)
          )
        ),
        a.push('abcdefghijklmnopqrstuvwxyz234567'.charAt(b[5 * e + 4] & 31))
    d = 0
    1 == c ? (d = 6) : 2 == c ? (d = 4) : 3 == c ? (d = 3) : 4 == c && (d = 1)
    for (c = 0; c < d; c++) a.pop()
    for (c = 0; c < d; c++) a.push('=')
    return a.join('')
  }
  function Ea(a) {
    return '--' == a.slice(2, 4) && 'xn' != a.slice(0, 2)
  }
  function Ha(a, b) {
    var c = 'viewer'
    c = void 0 === c ? null : c
    var d = new y(b),
      e = Ia(d.pathname, c)
    e += 'https:' === d.protocol ? '/s/' : '/'
    return Da(d.toString()).then(function (g) {
      var f = new y(b)
      f.protocol = 'https'
      g = g + '.' + a
      f.host = g
      f.hostname = g
      f.pathname = e + d.hostname + d.pathname
      return f.toString()
    })
  }
  function Ia(a, b) {
    b = void 0 === b ? null : b
    return ca(a) ? '/i' : ea(a) ? '/r' : 'viewer' === b ? '/v' : '/c'
  }
  function Ja(a) {
    var b = !1,
      c = null,
      d = a
    return function (e) {
      for (var g = [], f = 0; f < arguments.length; ++f) g[f - 0] = arguments[f]
      b || ((c = d.apply(self, g)), (b = !0), (d = null))
      return c
    }
  }
  function Ka(a, b, c) {
    function d(h) {
      f = null
      g = a.setTimeout(e, c)
      b.apply(null, h)
    }
    function e() {
      g = 0
      f && d(f)
    }
    var g = 0,
      f = null
    return function (h) {
      for (var k = [], m = 0; m < arguments.length; ++m) k[m - 0] = arguments[m]
      g ? (f = k) : d(k)
    }
  }
  function D(a, b, c) {
    this.j = a
    this.h = b
    this.ga = c
    this.ba = null
    this.j.IntersectionObserver && this.j === this.j.parent
      ? La(this)
      : ((this.ba = Ka(this.j, this.ha.bind(this), 500)),
        this.j.addEventListener('scroll', this.ba),
        this.ha(this.h))
  }
  function La(a) {
    var b = new a.j.IntersectionObserver(function (c) {
      c.forEach(function (d) {
        d.isIntersecting && (a.ga(), b.unobserve(a.h))
      })
    })
    b.observe(a.h)
  }
  D.prototype.ha = function () {
    var a = this.h.getBoundingClientRect().top
    this.j.innerHeight > a &&
      (this.ga(), this.j.removeEventListener('scroll', this.ba))
  }
  function Ma(a) {
    if ('string' != typeof a) return a
    if ('{' != a.charAt(0)) return null
    try {
      return JSON.parse(a)
    } catch (b) {
      return null
    }
  }
  function E(a, b, c) {
    this.j = a
    this.Z = b
    this.la = c
  }
  E.prototype.addEventListener = function (a, b) {
    var c = this
    this.j.addEventListener('message', function (d) {
      d.origin == c.Z && d.source == c.la && b(d)
    })
  }
  E.prototype.postMessage = function (a) {
    this.la.postMessage(a, 'null' === this.Z ? '*' : this.Z)
  }
  E.prototype.start = function () {}
  function Na(a) {
    this.j = null
    this.aa = a
    this.sa = !1
    this.V = null
    this.ma = !0
    this.ua = 0
    this.ea = {}
    this.Y = {}
    this.ia = null
    this.aa.addEventListener('message', this.ra.bind(this))
    this.aa.start()
  }
  function Oa(a, b, c) {
    var d = F.cdnProxyRegex
    return new Promise(function (e) {
      function g(f) {
        var h = Ma(f.data)
        !h ||
          !(f.origin == c || (d && d.test(f.origin))) ||
          (f.source && f.source != b) ||
          '__AMPHTML__' !== h.app ||
          'channelOpen' !== h.name ||
          (a.removeEventListener('message', g),
          (f = new E(a, f.origin, b)),
          (f = new Na(f)),
          Pa(f, h.requestid, 'channelOpen', null),
          e(f))
      }
      a.addEventListener('message', g)
    })
  }
  l = Na.prototype
  l.registerHandler = function (a, b) {
    this.Y[a] = b
  }
  l.unregisterHandler = function (a) {
    delete this.Y[a]
  }
  l.setDefaultHandler = function (a) {
    this.ia = a
  }
  l.ra = function (a) {
    if ((a = Ma(a.data)) && '__AMPHTML__' === a.app)
      if (this.V && this.ma && a.messagingToken !== this.V)
        G(this, 'amp-viewer-messaging: handleMessage_ error: ', 'invalid token')
      else if ('q' === a.type) Qa(this, a)
      else if ('s' === a.type) {
        var b = a.requestid,
          c = this.ea[b]
        c &&
          (delete this.ea[b],
          a.error
            ? (G(
                this,
                'amp-viewer-messaging: handleResponse_ error: ',
                a.error
              ),
              c.reject(Error('Request ' + a.name + ' failed: ' + a.error)))
            : c.resolve(a.data))
      }
  }
  l.sendRequest = function (a, b, c) {
    var d = this,
      e = ++this.ua,
      g = void 0
    c &&
      (g = new Promise(function (f, h) {
        d.ea[e] = { resolve: f, reject: h }
      }))
    H(this, {
      app: '__AMPHTML__',
      requestid: e,
      type: 'q',
      name: a,
      data: b,
      rsvp: c,
    })
    return g
  }
  function Pa(a, b, c, d) {
    H(a, { app: '__AMPHTML__', requestid: b, type: 's', name: c, data: d })
  }
  function Ra(a, b, c, d) {
    var e = d ? (d.message ? d.message : String(d)) : 'unknown error'
    G(a, 'amp-viewer-messaging: sendResponseError_, message name: ' + c, e)
    H(a, {
      app: '__AMPHTML__',
      requestid: b,
      type: 's',
      name: c,
      data: null,
      error: e,
    })
  }
  function H(a, b) {
    var c = Object.assign(b, {})
    a.V && !a.ma && (c.messagingToken = a.V)
    a.aa.postMessage(a.sa ? JSON.stringify(c) : c)
  }
  function Qa(a, b) {
    var c = a.Y[b.name]
    c || (c = a.ia)
    if (!c)
      throw (
        ((c = Error(
          'Cannot handle request because no default handler is set!'
        )),
        (c.args = b.name),
        c)
      )
    c = c(b.name, b.data, !!b.rsvp)
    if (b.rsvp) {
      var d = b.requestid
      if (!c)
        throw (
          (Ra(a, d, b.name, Error('no response')),
          Error('expected response but none given: ' + b.name))
        )
      c.then(
        function (e) {
          Pa(a, d, b.name, e)
        },
        function (e) {
          Ra(a, d, b.name, e)
        }
      )
    }
  }
  function G(a, b, c) {
    if (a.j) {
      var d = 'amp-messaging-error-logger: ' + b
      d +=
        ' data: ' + (c ? (c.message ? c.message : String(c)) : 'unknown error')
      a.j.viewerState = d
    }
  }
  function Sa(a) {
    this.j = a
    this.C = {
      startY: 0,
      lastDelta: 0,
      touchStartTimeMs: null,
      touchEndTimeMs: null,
      touchMoveTimeMs: null,
    }
    this.o = {
      startY: 0,
      isRunning: !1,
      acceleration: 1,
      speedLimit: 0.3,
      startTimeMs: null,
      maxTimeBetweenSwipesMs: 250,
      moveTimeThresholdMs: 100,
      durationMs: null,
      meetsDeltaYThreshold: !1,
      deltaYThresholdPx: 5,
      deltaY: null,
      offsetThresholdPx: 30,
      offsetPx: null,
      multiplier: 1,
    }
  }
  l = Sa.prototype
  l.onTouchStart = function (a, b) {
    this.C.startY = b
    this.C.touchStartTimeMs = a
    this.o.startY = this.j.scrollY
    this.o.multiplier =
      this.o.isRunning &&
      this.C.touchEndTimeMs - this.C.touchStartTimeMs <
        this.o.maxTimeBetweenSwipesMs
        ? this.o.multiplier + this.o.acceleration
        : 1
    this.o.isRunning = !1
  }
  l.onTouchMove = function (a, b) {
    this.o.acceleration = Math.abs(this.o.deltaY / (a - this.C.touchMoveTimeMs))
    this.C.touchMoveTimeMs = a
    Ka(this.j, this.va.bind(this, b), 50)()
  }
  l.va = function (a) {
    this.o.deltaY = a - this.C.startY
    this.o.meetsDeltaYThreshold =
      Math.abs(this.o.deltaY) > this.o.deltaYThresholdPx
    this.o.meetsDeltaYThreshold && this.j.scrollBy(0, -this.o.deltaY)
  }
  l.onTouchEnd = function (a) {
    var b = this
    this.C.touchEndTimeMs = a
    if (this.o.meetsDeltaYThreshold) {
      var c = this.C.touchEndTimeMs - this.C.touchMoveTimeMs
      this.o.offsetPx = Ta(this)
      c < this.o.moveTimeThresholdMs &&
        Math.abs(this.o.offsetPx) > this.o.offsetThresholdPx &&
        ((this.o.durationMs = 1.2 * this.j.innerHeight),
        (this.o.isRunning = !0),
        requestAnimationFrame(function (d) {
          b.o.startTimeMs = d
          b.o.startY = b.j.scrollY
          b.ca(d)
        }))
      this.o.multiplier = 1
      this.C.startY = 0
      this.o.deltaY = 0
    }
  }
  function Ta(a) {
    var b = Math.pow(a.o.acceleration, 2) * a.j.innerHeight
    b = Math.min(a.j.innerHeight * a.o.speedLimit, b)
    return (b *= 0 < a.o.deltaY ? -a.o.multiplier : a.o.multiplier)
  }
  l.ca = function (a) {
    var b = a - this.o.startTimeMs
    if (!(b > this.o.durationMs)) {
      a = b / this.o.durationMs
      a = 1 - --a * a * a * a
      var c = this.o.startY + a * this.o.offsetPx
      this.o.isRunning
        ? (this.j.scroll(0, c), requestAnimationFrame(this.ca.bind(this)))
        : cancelAnimationFrame(requestAnimationFrame(this.ca.bind(this)))
    }
  }
  function I(a) {
    return a || {}
  }
  function J() {
    this.pa = 100
    this.W = this.da = 0
    this.T = Object.create(null)
  }
  J.prototype.has = function (a) {
    return !!this.T[a]
  }
  J.prototype.get = function (a) {
    var b = this.T[a]
    if (b) return (b.access = ++this.W), b.payload
  }
  J.prototype.put = function (a, b) {
    this.has(a) || this.da++
    this.T[a] = { payload: b, access: this.W }
    if (!(this.da <= this.pa)) {
      a = this.T
      var c = this.W + 1,
        d
      for (d in a) {
        var e = a[d].access
        if (e < c) {
          c = e
          var g = d
        }
      }
      void 0 !== g && (delete a[g], this.da--)
    }
  }
  function Ua(a, b) {
    var c
    'number' !== typeof c && (c = 0)
    return c + b.length > a.length ? !1 : -1 !== a.indexOf(b, c)
  }
  var Va = /(?:^[#?]?|&)([^=&]+)(?:=([^&]*))?/g
  function Wa(a, b) {
    var c = (b = void 0 === b ? '' : b)
    try {
      return decodeURIComponent(a)
    } catch (d) {
      return c
    }
  }
  function Xa(a) {
    var b = Object.create(null)
    if (!a) return b
    for (var c; (c = Va.exec(a)); ) {
      var d = Wa(c[1], c[1])
      c = c[2] ? Wa(c[2].replace(/\+/g, ' '), c[2]) : ''
      b[d] = c
    }
    return b
  }
  var Ya = ''
  function K(a) {
    var b = a || self
    if (b.__AMP_MODE) b = b.__AMP_MODE
    else {
      var c = Xa(b.location.originalHash || b.location.hash)
      Ya ||
        (Ya =
          b.AMP_CONFIG && b.AMP_CONFIG.v ? b.AMP_CONFIG.v : '012105210438003')
      var d = Xa(b.location.originalHash || b.location.hash)
      d = !(
        !['1', 'actions', 'amp', 'amp4ads', 'amp4email'].includes(
          d.development
        ) && !b.AMP_DEV_MODE
      )
      b = b.__AMP_MODE = {
        localDev: !1,
        development: d,
        examiner: '2' == c.development,
        esm: !1,
        geoOverride: c['amp-geo'],
        minified: !0,
        test: !1,
        log: c.log,
        version: '2105210438003',
        rtvVersion: Ya,
      }
    }
    return b
  }
  function Za(a) {
    return a ? Array.prototype.slice.call(a) : []
  }
  var L = Array.isArray
  function $a(a, b) {
    for (var c = [], d = 0, e = 0; e < a.length; e++) {
      var g = a[e]
      b(g, e, a) ? c.push(g) : (d < e && (a[d] = g), d++)
    }
    d < a.length && (a.length = d)
    return c
  }
  function ab(a, b) {
    for (var c = 0; c < a.length; c++) if (b(a[c], c, a)) return c
    return -1
  }
  var M = self.AMP_CONFIG || {},
    bb =
      ('string' == typeof M.cdnProxyRegex
        ? new RegExp(M.cdnProxyRegex)
        : M.cdnProxyRegex) ||
      /^https:\/\/([a-zA-Z0-9_-]+\.)?cdn\.ampproject\.org$/
  function cb(a) {
    if (
      !self.document ||
      !self.document.head ||
      (self.location && bb.test(self.location.origin))
    )
      return null
    var b = self.document.head.querySelector('meta[name="' + a + '"]')
    return (b && b.getAttribute('content')) || null
  }
  var F = {
    thirdParty: M.thirdPartyUrl || 'https://3p.ampproject.net',
    thirdPartyFrameHost: M.thirdPartyFrameHost || 'ampproject.net',
    thirdPartyFrameRegex:
      ('string' == typeof M.thirdPartyFrameRegex
        ? new RegExp(M.thirdPartyFrameRegex)
        : M.thirdPartyFrameRegex) || /^d-\d+\.ampproject\.net$/,
    cdn: M.cdnUrl || cb('runtime-host') || 'https://cdn.ampproject.org',
    cdnProxyRegex: bb,
    localhostRegex: /^https?:\/\/localhost(:\d+)?$/,
    errorReporting:
      M.errorReportingUrl ||
      'https://us-central1-amp-error-reporting.cloudfunctions.net/r',
    betaErrorReporting:
      M.betaErrorReportingUrl ||
      'https://us-central1-amp-error-reporting.cloudfunctions.net/r-beta',
    localDev: M.localDev || !1,
    trustedViewerHosts: [
      /(^|\.)google\.(com?|[a-z]{2}|com?\.[a-z]{2}|cat)$/,
      /(^|\.)gmail\.(com|dev)$/,
    ],
    geoApi: M.geoApiUrl || cb('amp-geo-api'),
  }
  function db(a) {
    return 1 == (null == a ? void 0 : a.nodeType)
      ? a.tagName.toLowerCase() + (a.id ? '#' + a.id : '')
      : a
  }
  function eb(a, b, c, d) {
    var e = void 0 === c ? 'Assertion failed' : c
    if (b) return b
    a && !Ua(e, a) && (e += a)
    for (var g = 3, f = e.split('%s'), h = f.shift(), k = [h]; f.length; ) {
      var m = arguments[g++],
        p = f.shift()
      h += db(m) + p
      k.push(m, p.trim())
    }
    g = Error(h)
    g.messageArray = $a(k, function (n) {
      return '' !== n
    })
    self.__AMP_REPORT_ERROR && self.__AMP_REPORT_ERROR(g)
    throw g
  }
  function N(a, b, c, d, e) {
    L(e) ? a(c, e.concat([b])) : a(c, (e || d) + ': %s', b)
    return b
  }
  function fb(a) {
    var b
    if (
      null == (b = Object.getOwnPropertyDescriptor(a, 'message'))
        ? 0
        : b.writable
    )
      return a
    var c = a.stack
    b = Error(a.message)
    for (var d in a) b[d] = a[d]
    b.stack = c
    return b
  }
  function gb(a) {
    for (
      var b = null, c = '', d = q(arguments), e = d.next();
      !e.done;
      e = d.next()
    )
      (e = e.value),
        e instanceof Error && !b ? (b = fb(e)) : (c && (c += ' '), (c += e))
    b ? c && (b.message = c + ': ' + b.message) : (b = Error(c))
    return b
  }
  function hb() {}
  function ib(a, b) {
    return b.reduce(function (c, d) {
      return c + '&s[]=' + encodeURIComponent(String(db(d)))
    }, 'https://log.amp.dev/?v=012105210438003&id=' + encodeURIComponent(a))
  }
  function jb(a, b, c) {
    var d = this,
      e = (c = void 0 === c ? '' : c)
    this.win = a
    this.ta = b
    this.ka =
      this.win.console && this.win.console.log && '0' != K().log
        ? this.ta(parseInt(K().log, 10), K().development)
        : 0
    this.R = e
    this.U = null
    this.qa = Ja(function () {
      a.fetch(F.cdn + '/rtv/012105210438003/log-messages.simple.json')
        .then(function (g) {
          return g.json()
        }, hb)
        .then(function (g) {
          g && (d.U = g)
        })
    })
    this.K = this.assert.bind(this)
  }
  function O(a, b, c, d) {
    if (a.ka < c) return !1
    var e = a.win.console.log
    1 == c
      ? (e = a.win.console.error || e)
      : 3 == c
      ? (e = a.win.console.info || e)
      : 2 == c && (e = a.win.console.warn || e)
    c = L(d[0]) ? kb(a, d[0]) : d
    b = '[' + b + ']'
    'string' === typeof c[0] ? (c[0] = b + ' ' + c[0]) : c.unshift(b)
    e.apply(a.win.console, c)
    return !0
  }
  l = jb.prototype
  l.isEnabled = function () {
    return 0 != this.ka
  }
  l.fine = function (a, b) {
    for (var c = [], d = 1; d < arguments.length; ++d) c[d - 1] = arguments[d]
    O(this, a, 4, c)
  }
  l.info = function (a, b) {
    for (var c = [], d = 1; d < arguments.length; ++d) c[d - 1] = arguments[d]
    O(this, a, 3, c)
  }
  l.warn = function (a, b) {
    for (var c = [], d = 1; d < arguments.length; ++d) c[d - 1] = arguments[d]
    O(this, a, 2, c)
  }
  l.ja = function (a, b) {
    for (var c = [], d = 1; d < arguments.length; ++d) c[d - 1] = arguments[d]
    if (!O(this, a, 1, c)) return this.createError.apply(this, c)
  }
  l.error = function (a, b) {
    var c = this.ja.apply(this, arguments)
    c && ((c.name = a || c.name), self.__AMP_REPORT_ERROR(c))
  }
  l.expectedError = function (a, b) {
    var c = this.ja.apply(this, arguments)
    c && ((c.expected = !0), self.__AMP_REPORT_ERROR(c))
  }
  l.createError = function (a) {
    var b = gb.apply(null, arguments)
    lb(this, b)
    return b
  }
  l.createExpectedError = function (a) {
    var b = gb.apply(null, arguments)
    lb(this, b)
    b.expected = !0
    return b
  }
  l.assert = function (a, b, c) {
    return L(b)
      ? this.assert.apply(this, [a].concat(kb(this, b)))
      : eb.apply(null, [this.R].concat(Array.prototype.slice.call(arguments)))
  }
  l.assertElement = function (a, b) {
    return N(
      this.K,
      a,
      1 == (null == a ? void 0 : a.nodeType),
      'Element expected',
      b
    )
  }
  l.assertString = function (a, b) {
    return N(this.K, a, 'string' == typeof a, 'String expected', b)
  }
  l.assertNumber = function (a, b) {
    return N(this.K, a, 'number' == typeof a, 'Number expected', b)
  }
  l.assertArray = function (a, b) {
    return N(this.K, a, L(a), 'Array expected', b)
  }
  l.assertBoolean = function (a, b) {
    return N(this.K, a, !!a === a, 'Boolean expected', b)
  }
  l.assertEnumValue = function (a, b, c) {
    var d = this.K
    a: {
      for (var e in a)
        if (a[e] === b) {
          a = !0
          break a
        }
      a = !1
    }
    return N(
      d,
      b,
      a,
      'Unknown ' + (void 0 === c ? 'enum' : c) + ' value: "' + b + '"'
    )
  }
  function lb(a, b) {
    b = fb(b)
    a.R
      ? b.message
        ? -1 == b.message.indexOf(a.R) && (b.message += a.R)
        : (b.message = a.R)
      : 0 <= b.message.indexOf('\u200b\u200b\u200b') &&
        (b.message = b.message.replace('\u200b\u200b\u200b', ''))
  }
  function kb(a, b) {
    var c = b.shift()
    K(a.win).development && a.qa()
    return a.U && c in a.U ? [a.U[c]].concat(b) : ['More info at ' + ib(c, b)]
  }
  self.__AMP_LOG = self.__AMP_LOG || {
    user: null,
    dev: null,
    userForEmbed: null,
  }
  var P = self.__AMP_LOG,
    Q = null
  function mb() {
    if (!Q) throw Error('failed to call initLogConstructor')
    return new Q(
      self,
      function (a, b) {
        return b || 1 <= a ? 4 : 2
      },
      '\u200b\u200b\u200b'
    )
  }
  function nb() {
    if (P.dev) return P.dev
    if (!Q) throw Error('failed to call initLogConstructor')
    return (P.dev = new Q(self, function (a) {
      return 3 <= a ? 4 : 2 <= a ? 3 : 0
    }))
  }
  I({ c: !0, v: !0, a: !0, ad: !0 })
  var ob, pb
  function qb(a, b, c) {
    if (c && c.has(b)) return c.get(b)
    a.href = b
    a.protocol || (a.href = a.href)
    var d = {
      href: a.href,
      protocol: a.protocol,
      host: a.host,
      hostname: a.hostname,
      port: '0' == a.port ? '' : a.port,
      pathname: a.pathname,
      search: a.search,
      hash: a.hash,
      origin: null,
    }
    '/' !== d.pathname[0] && (d.pathname = '/' + d.pathname)
    if (
      ('http:' == d.protocol && 80 == d.port) ||
      ('https:' == d.protocol && 443 == d.port)
    )
      (d.port = ''), (d.host = d.hostname)
    d.origin =
      a.origin && 'null' != a.origin
        ? a.origin
        : 'data:' != d.protocol && d.host
        ? d.protocol + '//' + d.host
        : d.href
    c && c.put(b, d)
    return d
  }
  function rb(a) {
    var b = [],
      c
    for (c in a) {
      var d = a[c]
      if (null != d)
        if (L(d))
          for (var e = 0; e < d.length; e++) {
            var g = d[e]
            b.push(encodeURIComponent(c) + '=' + encodeURIComponent(g))
          }
        else b.push(encodeURIComponent(c) + '=' + encodeURIComponent(d))
    }
    return b.join('&')
  }
  function sb(a) {
    var b = a.indexOf('#')
    return -1 == b ? a : a.substring(0, b)
  }
  function tb(a) {
    var b = a.indexOf('#')
    return -1 == b ? '' : a.substring(b)
  }
  function ub(a) {
    'string' == typeof a &&
      (ob ||
        ((ob = self.document.createElement('a')),
        (pb = self.__AMP_URL_CACHE || (self.__AMP_URL_CACHE = new J()))),
      (a = qb(ob, a, pb)))
    return F.cdnProxyRegex.test(a.origin)
  }
  function vb(a) {
    var b = a.indexOf('?')
    if (-1 == b) return a
    var c = tb(a)
    return a.substring(0, b) + c
  } /*
 https://mths.be/cssescape v1.5.1 by @mathias | MIT license */
  var R,
    wb = 'Webkit webkit Moz moz ms O o'.split(' ')
  function S(a, b, c) {
    var d = a.style
    if (!b.startsWith('--')) {
      R || (R = Object.create(null))
      var e = R[b]
      if (!e) {
        e = b
        if (void 0 === d[b]) {
          var g = b.charAt(0).toUpperCase() + b.slice(1)
          b: {
            for (var f = 0; f < wb.length; f++) {
              var h = wb[f] + g
              if (void 0 !== d[h]) {
                g = h
                break b
              }
            }
            g = ''
          }
          void 0 !== d[g] && (e = g)
        }
        R[b] = e
      }
      b = e
    }
    b && (b.startsWith('--') ? a.style.setProperty(b, c) : (a.style[b] = c))
  }
  function xb(a) {
    for (var b = ['transform', 'transition'], c = 0; c < b.length; c++)
      S(a, b[c], null)
  }
  var T
  function yb(a, b) {
    var c = a,
      d = b
    var e = function (f) {
      try {
        return d(f)
      } catch (h) {
        throw (self.__AMP_REPORT_ERROR(h), h)
      }
    }
    var g = zb()
    c.addEventListener('transitionend', e, g ? void 0 : !1)
    return function () {
      c && c.removeEventListener('transitionend', e, g ? void 0 : !1)
      e = c = d = null
    }
  }
  function zb() {
    if (void 0 !== T) return T
    T = !1
    try {
      var a = {
        get capture() {
          T = !0
        },
      }
      self.addEventListener('test-options', null, a)
      self.removeEventListener('test-options', null, a)
    } catch (b) {}
    return T
  }
  function U(a, b, c) {
    var d = { detail: c }
    Object.assign(d, void 0)
    if ('function' == typeof a.CustomEvent) return new a.CustomEvent(b, d)
    a = a.document.createEvent('CustomEvent')
    a.initCustomEvent(b, !!d.bubbles, !!d.cancelable, c)
    return a
  }
  function Ab(a, b) {
    var c = b,
      d = yb(a, function (e) {
        try {
          c(e)
        } finally {
          ;(c = null), d()
        }
      })
  }
  var Bb = ['cdn.ampproject.org', 'www.bing-amp.com'],
    Cb = ['allow-top-navigation'],
    Db = { BACK: 'back-button', CLOSE: 'close-button' },
    V = {},
    W =
      ((V.BASE = 'amp-story-player-exit-control-button'),
      (V.HIDDEN = 'amp-story-player-hide-button'),
      (V['back-button'] = 'amp-story-player-back-button'),
      (V['close-button'] = 'amp-story-player-close-button'),
      V),
    Eb = {},
    Fb =
      ((Eb['back-button'] = 'amp-story-player-back'),
      (Eb['close-button'] = 'amp-story-player-close'),
      Eb)
  function Gb(a, b) {
    this.j = a
    this.h = b
    this.I = a.document
    this.oa = this.I.createElement('a')
    this.A = []
    this.G = null
    this.L = this.B = 0
    this.H = this.O = this.F = null
    this.C = { startX: 0, startY: 0, lastX: 0, isSwipeX: null }
    this.M = null
    this.na = new w()
    this.h.buildPlayer = this.buildPlayer.bind(this)
    this.h.layoutPlayer = this.layoutPlayer.bind(this)
    this.h.getElement = this.getElement.bind(this)
    this.h.getStories = this.getStories.bind(this)
    this.h.load = this.load.bind(this)
    this.h.show = this.show.bind(this)
    this.h.add = this.add.bind(this)
    this.h.play = this.play.bind(this)
    this.h.pause = this.pause.bind(this)
    this.h.go = this.go.bind(this)
    this.h.mute = this.mute.bind(this)
    this.h.unmute = this.unmute.bind(this)
    this.h.getStoryState = this.getStoryState.bind(this)
    this.h.rewind = this.rewind.bind(this)
    this.J = new Sa(a)
    this.$ = !0
    this.fa = null
    return this.h
  }
  l = Gb.prototype
  l.load = function () {
    if (!this.h.isConnected)
      throw Error(
        '[amp-story-player] element must be connected to the DOM before calling load().'
      )
    if (this.h.N)
      throw Error(
        '[amp-story-player] calling load() on an already loaded element.'
      )
    this.buildPlayer()
    this.layoutPlayer()
  }
  function Hb(a, b) {
    b.idx = a.A.length
    b.distance = b.idx - a.B
    b.connectedDeferred = new w()
    a.A.push(b)
  }
  l.add = function (a) {
    if (!(0 >= a.length)) {
      var b = function (g) {
        return g && g.href
      }
      if (!Array.isArray(a) || !a.every(b))
        throw Error('"stories" parameter has the wrong structure')
      for (var c = this.A.length, d = 0; d < a.length; d++) {
        var e = a[d]
        Hb(this, e)
        Ib(this, e)
      }
      X(this, c)
    }
  }
  l.play = function () {
    this.h.P || this.layoutPlayer()
    Jb(this, !1)
  }
  l.pause = function () {
    Jb(this, !0)
  }
  function Jb(a, b) {
    a.$ = !b
    Kb(a.A[a.B], b ? 'paused' : 'visible')
  }
  l.getElement = function () {
    return this.h
  }
  l.getStories = function () {
    return this.A
  }
  l.buildPlayer = function () {
    if (!this.h.N) {
      Lb(this)
      this.X()
      Mb(this)
      Nb(this)
      if (!this.F) {
        var a = this.h.getAttribute('amp-cache')
        a &&
          !Bb.includes(a) &&
          console.error(
            '[amp-story-player]',
            'Unsupported cache specified, use one of following: ' + Bb
          )
        if ((a = this.h.querySelector('script'))) {
          if (
            'SCRIPT' != a.tagName ||
            !a.hasAttribute('type') ||
            'APPLICATION/JSON' != a.getAttribute('type').toUpperCase()
          )
            throw Error('<script> child must have type="application/json"')
          try {
            this.F = JSON.parse(a.textContent)
          } catch (b) {
            console.error('[amp-story-player] ', b)
          }
        }
      }
      Ob(this, this.A.length - this.B - 1)
      this.F &&
        (a = this.F.behavior) &&
        'boolean' === typeof a.autoplay &&
        (this.$ = a.autoplay)
      this.F &&
        (a = this.F.display) &&
        'auto' === a.attribution &&
        (this.fa = 'auto')
      this.F && (a = this.F.behavior) && !1 === a.pageScroll && (this.J = null)
      Pb(this)
      this.h.dispatchEvent(U(this.j, 'ready', I({})))
      this.h.isReady = !0
      this.h.N = !0
    }
  }
  function Lb(a) {
    Za(a.h.querySelectorAll('a')).forEach(function (b) {
      var c = b.querySelector('img[data-amp-story-player-poster-img]'),
        d = c && c.getAttribute('src')
      b = {
        href: b.href,
        title: (b.textContent && b.textContent.trim()) || null,
        posterImage: b.getAttribute('data-poster-portrait-src') || d,
      }
      Hb(a, b)
    })
  }
  function Mb(a) {
    a.A.forEach(function (b) {
      Ib(a, b)
    })
  }
  l.X = function () {
    this.G = this.I.createElement('div')
    this.G.classList.add('i-amphtml-story-player-main-container')
    var a = this.I.createElement('div')
    a.classList.add(
      'i-amphtml-fill-content',
      'i-amphtml-story-player-shadow-root-intermediary'
    )
    this.h.appendChild(a)
    var b = this.h.attachShadow ? a.attachShadow({ mode: 'open' }) : a,
      c = this.I.createElement('style')
    c.textContent =
      ":host{all:initial;color:initial}.story-player-iframe{height:100%;width:100%;-ms-flex:0 0 100%;flex:0 0 100%;border:0;opacity:0;transition:opacity 500ms ease;position:absolute}.i-amphtml-story-player-main-container{height:100%;position:relative;overflow:hidden;transform-style:preserve-3d}.i-amphtml-story-player-loaded .story-player-iframe{opacity:1;transition:transform 200ms cubic-bezier(0.4,0,0.2,1)}.i-amphtml-story-player-no-navigation-transition .story-player-iframe{transition-duration:0.01s}.i-amphtml-story-player-main-container .story-player-iframe[i-amphtml-iframe-position=\"0\"],.i-amphtml-story-player-main-container iframe:first-of-type{transform:translateZ(1px)}.i-amphtml-story-player-main-container .story-player-iframe[i-amphtml-iframe-position=\"1\"],.i-amphtml-story-player-main-container iframe:nth-of-type(2),.i-amphtml-story-player-main-container iframe:nth-of-type(3){transform:translate3d(100%,0,0)}.i-amphtml-story-player-main-container .story-player-iframe[i-amphtml-iframe-position=\"-1\"]{transform:translate3d(-100%,0,0)}.amp-story-player-exit-control-button{position:absolute;height:48px;width:48px;background-repeat:no-repeat;background-position:50%;margin-top:7px;background-size:28px;border:0px;background-color:transparent;outline:transparent;cursor:pointer;z-index:1}.amp-story-player-close-button{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' width='24' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3C/svg%3E\")}.amp-story-player-back-button{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' width='24' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'/%3E%3C/svg%3E\")}.amp-story-player-hide-button{display:none}\n/*# sourceURL=/css/amp-story-player-iframe.css*/"
    b.appendChild(c)
    b.insertBefore(this.G, b.firstElementChild)
  }
  function Nb(a) {
    var b = a.h.getAttribute('exit-control')
    if (Object.values(Db).includes(b)) {
      var c = a.I.createElement('button')
      a.G.appendChild(c)
      c.classList.add(W[b])
      c.classList.add(W.BASE)
      c.addEventListener('click', function () {
        a.h.dispatchEvent(U(a.j, Fb[b], I({})))
      })
    }
  }
  function Ib(a, b) {
    var c = a.I.createElement('iframe')
    b.posterImage && S(c, 'backgroundImage', b.posterImage)
    c.classList.add('story-player-iframe')
    c.setAttribute('allow', 'autoplay')
    a: if (c.sandbox && c.sandbox.supports) {
      for (
        var d = [
            'allow-top-navigation-by-user-activation',
            'allow-popups-to-escape-sandbox',
          ],
          e = 0;
        e < d.length;
        e++
      ) {
        var g = d[e]
        if (!c.sandbox.supports(g)) {
          nb().info('3p-frame', "Iframe doesn't support %s", g)
          break a
        }
      }
      c.sandbox =
        d.join(' ') +
        ' allow-forms allow-modals allow-pointer-lock allow-popups allow-same-origin allow-scripts'
    }
    if (c.sandbox && c.sandbox.supports && !(0 >= c.sandbox.length))
      for (d = 0; d < Cb.length; d++) {
        e = Cb[d]
        if (!c.sandbox.supports(e)) throw Error("Iframe doesn't support: " + e)
        c.sandbox.add(e)
      }
    Qb(a, c)
    b.iframe = c
  }
  function Rb(a, b) {
    var c = b.iframe
    b.messagingPromise = new Promise(function (d) {
      Sb(a, b, c).then(
        function (e) {
          e.setDefaultHandler(function () {
            return u()
          })
          e.registerHandler('touchstart', function (g, f) {
            if ((g = Tb(f)))
              (a.C.startX = g.screenX),
                (a.C.startY = g.screenY),
                a.J && a.J.onTouchStart(f.timeStamp, g.clientY),
                a.h.dispatchEvent(
                  U(
                    a.j,
                    'amp-story-player-touchstart',
                    I({ touches: f.touches })
                  )
                )
          })
          e.registerHandler('touchmove', function (g, f) {
            a: if ((g = Tb(f)))
              if (
                (a.h.dispatchEvent(
                  U(
                    a.j,
                    'amp-story-player-touchmove',
                    I({ touches: f.touches, isNavigationalSwipe: a.C.isSwipeX })
                  )
                ),
                !1 === a.C.isSwipeX)
              )
                a.J && a.J.onTouchMove(f.timeStamp, g.clientY)
              else {
                f = g.screenX
                g = g.screenY
                a.C.lastX = f
                if (
                  null === a.C.isSwipeX &&
                  ((a.C.isSwipeX =
                    Math.abs(a.C.startX - f) > Math.abs(a.C.startY - g)),
                  !a.C.isSwipeX)
                )
                  break a
                Ub(a, { deltaX: f - a.C.startX, last: !1 })
              }
          })
          e.registerHandler('touchend', function (g, f) {
            a.h.dispatchEvent(
              U(
                a.j,
                'amp-story-player-touchend',
                I({ touches: f.touches, isNavigationalSwipe: a.C.isSwipeX })
              )
            )
            !0 === a.C.isSwipeX
              ? Ub(a, { deltaX: a.C.lastX - a.C.startX, last: !0 })
              : a.J && a.J.onTouchEnd(f.timeStamp)
            a.C.startX = 0
            a.C.startY = 0
            a.C.lastX = 0
            a.C.isSwipeX = null
            a.L = 0
          })
          e.registerHandler('selectDocument', function (g, f) {
            if (!a.H && (f.next || f.previous)) {
              if (f.next) {
                g = a.B + 1 === a.A.length
                var h = 'noNextStory'
              } else (g = 0 === a.B), (h = 'noPreviousStory')
              g && a.h.dispatchEvent(U(a.j, h, I({})))
            }
            f.next ? Vb(a) : f.previous && Wb(a)
          })
          e.sendRequest(
            'onDocumentState',
            I({ state: 'PAGE_ATTACHMENT_STATE' }),
            !1
          )
          e.sendRequest('onDocumentState', I({ state: 'CURRENT_PAGE_ID' }), !1)
          e.sendRequest('onDocumentState', I({ state: 'MUTED_STATE' }))
          e.registerHandler('documentStateUpdate', function (g, f) {
            switch (f.state) {
              case 'PAGE_ATTACHMENT_STATE':
                g = f.value
                f = !g
                var h = a.G.querySelector(
                  'button.amp-story-player-exit-control-button'
                )
                h &&
                  (f ? h.classList.remove(W.HIDDEN) : h.classList.add(W.HIDDEN))
                Xb(a, g)
                break
              case 'CURRENT_PAGE_ID':
                Yb(a, f.value, e)
                break
              case 'MUTED_STATE':
                a.h.dispatchEvent(
                  U(a.j, 'amp-story-muted-state', { muted: f.value })
                )
                break
              case 'AMP_STORY_PLAYER_EVENT':
                switch (((g = f.value), g)) {
                  case 'amp-story-player-skip-next':
                  case 'amp-story-player-skip-to-next':
                    Vb(a)
                    break
                  default:
                    a.h.dispatchEvent(U(a.j, g, I({})))
                }
            }
          })
          a.F &&
            a.F.controls &&
            (Zb(a, b.idx),
            e.sendRequest(
              'customDocumentUI',
              I({ controls: a.F.controls }),
              !1
            ))
          d(e)
        },
        function (e) {
          console.error('[amp-story-player]', e)
        }
      )
    })
  }
  function Zb(a, b) {
    if (b === a.A.length - 1) {
      var c = ab(a.F.controls, function (d) {
        return 'skip-next' === d.name || 'skip-to-next' === d.name
      })
      0 <= c && (a.F.controls[c].state = 'disabled')
    }
  }
  function Sb(a, b, c) {
    return $b(a, b.href).then(function (d) {
      return Oa(a.j, c.contentWindow, ac(a, d).origin)
    })
  }
  function Qb(a, b) {
    a.G.classList.add('i-amphtml-story-player-loading')
    b.onload = function () {
      a.G.classList.remove('i-amphtml-story-player-loading')
      a.G.classList.add('i-amphtml-story-player-loaded')
      a.h.classList.add('i-amphtml-story-player-loaded')
    }
    b.onerror = function () {
      a.G.classList.remove('i-amphtml-story-player-loading')
      a.G.classList.add('i-amphtml-story-player-error')
      a.h.classList.add('i-amphtml-story-player-error')
    }
  }
  l.layoutPlayer = function () {
    var a = this
    this.h.P ||
      (new D(this.j, this.h, function () {
        return a.na.resolve()
      }),
      X(this),
      (this.h.P = !0))
  }
  function bc(a) {
    var b = a.F.behavior.endpoint
    if (!b) return (a.O = !1), u()
    b = b.replace(/\${offset}/, a.A.length.toString())
    return fetch(b, { method: 'GET', headers: { Accept: 'application/json' } })
      .then(function (c) {
        return c.json()
      })
      .catch(function (c) {
        console.error('[amp-story-player]', c)
      })
  }
  function cc(a, b) {
    a.M = new w()
    b.messagingPromise.then(function (c) {
      return c.registerHandler('storyContentLoaded', function () {
        b.storyContentLoaded = !0
        a.M.resolve()
      })
    })
  }
  l.show = function (a, b, c) {
    var d = this
    b = void 0 === b ? null : b
    c = void 0 === c ? {} : c
    var e = b,
      g = dc(this, a),
      f = u()
    g.idx !== this.B &&
      ((this.B = g.idx),
      (f = X(this)),
      !1 === c.animate &&
        (this.G.classList.toggle(
          'i-amphtml-story-player-no-navigation-transition',
          !0
        ),
        Ab(g.iframe, function () {
          d.G.classList.remove(
            'i-amphtml-story-player-no-navigation-transition'
          )
        })),
      ec(this))
    return null != e
      ? f.then(function () {
          return fc(d, e)
        })
      : f
  }
  l.mute = function () {
    gc(this.A[this.B], !0)
  }
  l.unmute = function () {
    gc(this.A[this.B], !1)
  }
  l.getStoryState = function (a) {
    switch (a) {
      case 'page-attachment':
        hc(this)
    }
  }
  function ec(a) {
    var b = a.A.length - a.B - 1,
      c = U(a.j, 'navigation', { index: a.B, remaining: b })
    a.h.dispatchEvent(c)
    Ob(a, b)
  }
  function Ob(a, b) {
    a.F &&
      a.F.behavior &&
      ic(a) &&
      2 >= b &&
      bc(a)
        .then(function (c) {
          c && a.add(c)
        })
        .catch(function (c) {
          console.error('[amp-story-player]', c)
        })
  }
  function ic(a) {
    function b(d) {
      return 'end' === d.on && 'fetch' === d.action && d.endpoint
    }
    if (null !== a.O) return a.O
    var c = a.F.behavior
    a.O = c && c.on && c.action && b(c)
    return a.O
  }
  function Vb(a) {
    if (a.H || !Y(a, a.B + 1))
      a.H && Y(a, a.B + 1) ? a.go(1) : (a.B++, X(a), ec(a))
  }
  function Wb(a) {
    if (a.H || !Y(a, a.B - 1))
      a.H && Y(a, a.B - 1) ? a.go(-1) : (a.B--, X(a), ec(a))
  }
  l.go = function (a, b, c) {
    var d = this
    b = void 0 === b ? 0 : b
    c = void 0 === c ? {} : c
    var e = b,
      g = c
    if (0 !== a || 0 !== e) {
      if (!this.H && Y(this, this.B + a)) throw Error('Out of Story range.')
      var f = this.B + a,
        h =
          0 < a
            ? this.A[f % this.A.length]
            : this.A[((f % this.A.length) + this.A.length) % this.A.length],
        k = u()
      this.B !== h.idx && (k = this.show(h.href, null, g))
      k.then(function () {
        0 !== e && jc(d, e)
      })
    }
  }
  function kc(a, b) {
    var c = 0 === b.distance ? 0 : b.idx > a.B ? 1 : -1
    requestAnimationFrame(function () {
      var d = b.iframe
      xb(d)
      d.setAttribute('i-amphtml-iframe-position', c)
    })
  }
  function lc(a, b) {
    if (a.A[a.B].storyContentLoaded) return u()
    if (0 !== b.distance) return a.M.promise
    a.M &&
      a.M.reject(
        '[amp-story-player-dev] Cancelling previous story load promise.'
      )
    cc(a, b)
    return u()
  }
  function X(a, b) {
    for (
      var c = (b = void 0 === b ? a.B : b), d = [], e = {}, g = 0;
      g < a.A.length;
      e = { D: e.D, S: e.S }, g++
    )
      (e.D = a.A[(g + c) % a.A.length]),
        (e.S = e.D.distance),
        (e.D.distance = Math.abs(a.B - e.D.idx)),
        1 >= e.S && 1 < e.D.distance && mc(e.D),
        1 >= e.D.distance && !e.D.iframe.isConnected && nc(a, e.D),
        1 < e.D.distance ||
          d.push(
            lc(a, e.D)
              .then(
                (function (f) {
                  return function () {
                    return $b(a, f.D.href)
                  }
                })(e)
              )
              .then(
                (function (f) {
                  return function (h) {
                    var k = f.D.iframe.src
                    if (0 >= k.length) k = !1
                    else {
                      k = sb(vb(k))
                      var m = sb(vb(h))
                      k = k === m
                    }
                    k ||
                      ((k = f.D),
                      (m = k.iframe),
                      (h = ac(a, h, 'prerender').href),
                      m.setAttribute('src', h),
                      k.title && m.setAttribute('title', k.title))
                  }
                })(e)
              )
              .then(function () {
                return a.na.promise
              })
              .then(
                (function (f) {
                  return function () {
                    0 === f.D.distance && a.$ && Kb(f.D, 'visible')
                    0 === f.S && 1 === f.D.distance && Kb(f.D, 'inactive')
                  }
                })(e)
              )
              .then(
                (function (f) {
                  return function () {
                    kc(a, f.D)
                    if (0 === f.D.distance)
                      try {
                        f.D.iframe.focus()
                      } catch (h) {}
                  }
                })(e)
              )
              .catch(function (f) {
                f.includes('amp-story-player-dev') ||
                  console.error('[amp-story-player]', f)
              })
          )
    return Promise.all(d)
  }
  function nc(a, b) {
    a.G.appendChild(b.iframe)
    Rb(a, b)
    b.connectedDeferred.resolve()
  }
  function mc(a) {
    a.storyContentLoaded = !1
    a.connectedDeferred = new w()
    a.iframe.setAttribute('src', '')
    a.iframe.remove()
  }
  function $b(a, b) {
    return (a = a.h.getAttribute('amp-cache')) && !ub(b) && Bb.includes(a)
      ? Ha(a, b).then(function (c) {
          return c
        })
      : Promise.resolve(b)
  }
  function ac(a, b, c) {
    c = void 0 === c ? 'inactive' : c
    var d = {
      visibilityState: c,
      origin: a.j.origin,
      showStoryUrlInfo: '0',
      storyPlayer: 'v0',
      cap: 'swipe',
    }
    'auto' === a.fa && (d.attribution = 'auto')
    var e = tb(b),
      g = Xa(e),
      f = Object.assign({}, g, d),
      h = sb(b)
    if (ub(b)) {
      var k = I({ amp_js_v: '0.1' })
      var m = h
      if ((b = rb(k))) {
        m = m.split('#', 2)
        var p = m[0].split('?', 2)
        b = p[0] + (p[1] ? '?' + p[1] + '&' + b : '?' + b)
        h = b += m[1] ? '#' + m[1] : ''
      } else h = m
    }
    var n = h + '#' + rb(f)
    return qb(a.oa, n)
  }
  function Kb(a, b) {
    a.messagingPromise.then(function (c) {
      return c.sendRequest('visibilitychange', { state: b }, !0)
    })
  }
  function gc(a, b) {
    a.messagingPromise.then(function (c) {
      c.sendRequest('setDocumentState', { state: 'MUTED_STATE', value: b })
    })
  }
  function hc(a) {
    a.A[a.B].messagingPromise.then(function (b) {
      b.sendRequest(
        'getDocumentState',
        { state: 'PAGE_ATTACHMENT_STATE' },
        !0
      ).then(function (c) {
        return Xb(a, c.value)
      })
    })
  }
  function fc(a, b) {
    a.A[a.B].messagingPromise.then(function (c) {
      return c.sendRequest('selectPage', { id: b })
    })
  }
  function dc(a, b) {
    var c = b
      ? ab(a.A, function (d) {
          return d.href === b
        })
      : a.B
    if (!a.A[c]) throw Error('Story URL not found in the player: ' + b)
    return a.A[c]
  }
  l.rewind = function (a) {
    var b = dc(this, a)
    ;(b.iframe.isConnected ? u() : b.connectedDeferred.promise)
      .then(function () {
        return b.messagingPromise
      })
      .then(function (c) {
        return c.sendRequest('rewind', {})
      })
  }
  function jc(a, b) {
    a.A[a.B].messagingPromise.then(function (c) {
      return c.sendRequest('selectPage', { delta: b })
    })
  }
  function Yb(a, b, c) {
    c.sendRequest('getDocumentState', I({ state: 'STORY_PROGRESS' }), !0).then(
      function (d) {
        a.h.dispatchEvent(
          U(a.j, 'storyNavigation', I({ pageId: b, progress: d.value }))
        )
      }
    )
  }
  function Xb(a, b) {
    a.h.dispatchEvent(
      U(a.j, b ? 'page-attachment-open' : 'page-attachment-close', I({}))
    )
  }
  function Ub(a, b) {
    if (!(1 >= a.A.length)) {
      var c = b.deltaX
      if (!0 === b.last) {
        var d = Math.abs(c)
        1 === a.L && (50 < d && (Z(a) || a.H) ? Vb(a) : oc(a))
        2 === a.L && (50 < d && (Z(a) || a.H) ? Wb(a) : oc(a))
      } else pc(a, c)
    }
  }
  function oc(a) {
    var b = a.A[a.B].iframe
    requestAnimationFrame(function () {
      xb(b)
    })
    var c = Z(a)
    c &&
      requestAnimationFrame(function () {
        xb(c.iframe)
      })
  }
  function Z(a) {
    var b = 1 === a.L ? a.B + 1 : a.B - 1
    return Y(a, b) ? null : a.A[b]
  }
  function Y(a, b) {
    return b >= a.A.length || 0 > b
  }
  function Pb(a) {
    if (null === a.H)
      if (a.F) {
        var b = a.F.behavior,
          c = function (d) {
            return 'end' === d.on && 'circular-wrapping' === d.action
          }
        a.H = b && b.on && b.action && c(b)
      } else a.H = !1
  }
  function pc(a, b) {
    if (0 > b) {
      a.L = 1
      var c = 'translate3d(calc(100% + ' + b + 'px), 0, 0)'
    } else (a.L = 2), (c = 'translate3d(calc(' + b + 'px - 100%), 0, 0)')
    var d = a.A[a.B].iframe,
      e = 'translate3d(' + b + 'px, 0, 0)'
    requestAnimationFrame(function () {
      var f = { transform: e, transition: 'none' },
        h
      for (h in f) S(d, h, f[h])
    })
    var g = Z(a)
    g &&
      requestAnimationFrame(function () {
        var f = g.iframe,
          h = { transform: c, transition: 'none' },
          k
        for (k in h) S(f, k, h[k])
      })
  }
  function Tb(a) {
    a = a.touches
    if (!a || 1 > a.length) return null
    a = a[0]
    return {
      screenX: a.screenX,
      screenY: a.screenY,
      clientX: a.clientX,
      clientY: a.clientY,
    }
  }
  function qc() {
    this.j = self
  }
  function rc(a, b) {
    function c() {
      b.layoutPlayer()
      a.j.removeEventListener('scroll', c)
    }
    new D(a.j, b, function () {
      return b.layoutPlayer()
    })
    a.j.addEventListener('scroll', c)
  }
  qc.prototype.loadPlayers = function () {
    var a = this.j.document.getElementsByTagName('amp-story-player')
    Q = jb
    nb()
    P.user || (P.user = mb())
    for (var b = 0; b < a.length; b++) {
      var c = new Gb(this.j, a[b])
      c.buildPlayer()
      rc(this, c)
    }
  }
  qc.prototype.loadEntryPoints = function () {
    var a = this.j.document.getElementsByTagName('amp-story-entry-point')
    Q = jb
    nb()
    P.user || (P.user = mb())
    for (var b = 0; b < a.length; b++) {
      var c = new r(this.j, a[b])
      c.buildCallback()
      rc(this, c)
    }
  }
  function sc(a) {
    return 'loading' != a.readyState && 'uninitialized' != a.readyState
  }
  function tc(a, b) {
    var c = sc(a)
    if (c) b(a)
    else {
      var d = function () {
        sc(a) &&
          (c || ((c = !0), b(a)), a.removeEventListener('readystatechange', d))
      }
      a.addEventListener('readystatechange', d)
    }
  }
  ;(function (a, b) {
    tc(a, b)
  })(self.document, function () {
    new qc().loadPlayers()
  })
  globalThis.AmpStoryPlayer = Gb
})()

//# sourceMappingURL=amp-story-player-v0.js.map
